import { render, staticRenderFns } from "./MemorialCard.vue?vue&type=template&id=447bfcf0&"
import script from "./MemorialCard.vue?vue&type=script&lang=js&"
export * from "./MemorialCard.vue?vue&type=script&lang=js&"
import style0 from "./MemorialCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports